import { UserInterface } from '../../app/shared/interfaces/global';

export const userInitializeState: UserInterface = {
  id: 0,
  email: '',
  phone: '',
  created_at: null,
  avatar_private: false,
  avatar_url: '',
  country_id: 0,
  language_id: 0,
  last_name: '',
  name: '',
  region_id: 0,
  status: 1,
  timezone_id: 0,
};
